import {HelperOptions} from 'handlebars';

/**
 * Helper for comparing two expressions with the given operator.
 *
 * @param {any} left Left part of the comparison
 * @param {string} operator Operator for the comparison
 * @param {any} right Right part of the comparison
 * @param {HelperOptions} options Helper options
 * @returns {string|null}
 * @author Philipp Seiler <sep@earlybird.at>
 */
const ifCondition = (left: any, operator: string, right: any, options: HelperOptions): string | null => {
  let result: any;
  switch (operator) {
    case '==':
      // tslint:disable-next-line:triple-equals
      result = (left == right);
      break;
    case '===':
      result = (left === right);
      break;
    case '!=':
      // tslint:disable-next-line:triple-equals
      result = (left != right);
      break;
    case '!==':
      result = (left !== right);
      break;
    case '<':
      result = (left < right);
      break;
    case '<=':
      result = (left <= right);
      break;
    case '>':
      result = (left > right);
      break;
    case '>=':
      result = (left >= right);
      break;
    case '&&':
      result = (left && right);
      break;
    case '||':
      result = (left || right);
      break;
    default:
      result = false;
  }
  if (options.hash.hasOwnProperty('then') || options.hash.hasOwnProperty('else')) {
    if (result) {
      if (options.hash.hasOwnProperty('then')) {
        return options.hash.then;
      }
      return null;
    } else {
      if (options.hash.hasOwnProperty('else')) {
        return options.hash.else;
      }
      return null;
    }
  } else {
    return result ? options.fn(this) : options.inverse(this);
  }
};
export default ifCondition;
